import React from 'react';
import { CheckboxFormField } from '../../../../components/Fieldset/CheckboxFormField';
import { PhoneNumberFormField } from '../../../../components/Fieldset/PhoneNumberFormField';
import { SelectFormField } from '../../../../components/Fieldset/SelectFormField';
import { TextInputFormField } from '../../../../components/Fieldset/TextInputFormField';
import { createOptionsList } from '../../../../services/common/miscUtils';
import { CountryCodeEnum } from '../../../../types/forms';
import { PrivateProspectFormModel } from './formModel';
import { SearchableTextInputFormField } from '../../../../components/Fieldset/SearchableTextInputFormField';

const typeSafeFormFieldName = (formFieldName: keyof PrivateProspectFormModel) => formFieldName;

export const createFormInputs = () => {
  return {
    firstName: (handleShowingCustomerSearchModal: () => void) => (
      <SearchableTextInputFormField
        fieldName={typeSafeFormFieldName('firstName')}
        labelTranslationKey="prospectPage:private:fields:firstName:label"
        placeholderTranslationKey="prospectPage:private:fields:firstName:placeholder"
        handleSearch={handleShowingCustomerSearchModal}
      />
    ),
    lastName: () => (
      <TextInputFormField
        fieldName={typeSafeFormFieldName('lastName')}
        labelTranslationKey="prospectPage:private:fields:lastName:label"
        placeholderTranslationKey="prospectPage:private:fields:lastName:placeholder"
      />
    ),
    countryCode: () => (
      <SelectFormField
        fieldName={typeSafeFormFieldName('countryCode')}
        labelTranslationKey="prospectPage:private:fields:countryCode:label"
        optionList={createOptionsList(CountryCodeEnum, 'prospectPage:private', 'countryCode')}
      />
    ),
    email: () => (
      <TextInputFormField
        fieldName={typeSafeFormFieldName('email')}
        labelTranslationKey="prospectPage:private:fields:email:label"
        placeholderTranslationKey="prospectPage:private:fields:email:placeholder"
        validateOnChange
      />
    ),
    mobileNumber: () => (
      <PhoneNumberFormField
        fieldName={typeSafeFormFieldName('mobileNumber')}
        labelTranslationKey="prospectPage:private:fields:mobileNumber:label"
        placeholderTranslationKey="prospectPage:private:fields:mobileNumber:placeholder"
        type="mobile"
      />
    ),
    vulnerableCustomer: () => (
      <CheckboxFormField
        labelTranslationKey="prospectPage:private:fields:vulnerableCustomer"
        fieldName={typeSafeFormFieldName('vulnerableCustomer')}
      />
    ),
  };
};
